import { createContext } from "react";
import { FrontendActor } from "../../entity/models/FrontendActor";

export const userContext = createContext<{ actor: FrontendActor; setActor: (actor: FrontendActor) => void }>({
  actor: null,
  setActor: null,
});
